import React from 'react';
import Skeleton from 'react-loading-skeleton';
import 'react-loading-skeleton/dist/skeleton.css';
import {
  Container,
  CardRow,
  ContentSection,
  TextBlock,
  ImageSection
} from './ShimmerWhatsNewCard.styles';
import { ShimmerWhatsNewCardProps } from './ShimmerWhatsNewCard.types';
import { skeletonProps } from '../Shimmer.types';

const ShimmerCard = () => (
  <CardRow>
    <ContentSection>
      <TextBlock>
        <Skeleton width={160} height={16} {...skeletonProps} />
        <Skeleton width={189} height={14} {...skeletonProps} />
        <Skeleton width={150} height={14} {...skeletonProps} />
      </TextBlock>
      <Skeleton width={76} height={14} {...skeletonProps} />
    </ContentSection>
    <ImageSection />
  </CardRow>
);

export const ShimmerWhatsNewCard = ({ count = 1, width, height }: ShimmerWhatsNewCardProps) => {
  return (
    <Container $width={width} $height={height}>
      {Array.from({ length: count }).map((_, i) => (
        <ShimmerCard key={i} />
      ))}
    </Container>
  );
};
